import React, { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import { PayPalButtons, usePayPalScriptReducer } from '@paypal/react-paypal-js'

const PaypalCheckout = (props) => {
  const { amount, onSuccess, onFail } = props
  const [{ isPending }] = usePayPalScriptReducer()

  const [key, setKey] = useState(0)
  
  const onCreateOrder = (data, actions) => {
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: `${amount}`,
          },
        },
      ],
    })
  }

  const onApproveOrder = (data, actions) => {
    return actions.order.capture().then((details) => {
      if (details.status && details.status === 'COMPLETED') {
        onSuccess(details)
      } else {
        onFail()
      }
    })
  }

  useEffect(() => {
    setKey(prev => prev + 1)
  }, [amount])
  
  return (
    <>
      {
        isPending ? (
          <Box>Loading...</Box>
        ) : (
          <Box sx={{ width: '100%' }}>
            <PayPalButtons
              key={key}
              style={{
                shape: 'rect',
                layout: 'horizontal',
                color: 'gold',
                label: 'paypal',
                tagline: false,
              }}
              createOrder={(data, actions) => onCreateOrder(data, actions)}
              onApprove={(data, actions) => onApproveOrder(data, actions)}
            />
          </Box>
        )
      }
    </>
  )
}

export default PaypalCheckout